import { pgEnumFromObject } from "../../../functions/pgEnumFromObject";
import { DELETION_REQUEST_STATUS } from "../constants/DELETION_REQUEST_STATUS";

/**
 * @group Enums
 * @summary
 * <blockquote>PostgreSQL enum for data deletion request status</blockquote>
 */
export const deletionRequestStatusEnum = pgEnumFromObject(
  'deletion_request_status',
  DELETION_REQUEST_STATUS
);

